import { Checkbox as MUICheckbox, FormControlLabel, Grid } from '@material-ui/core';
import React, { memo } from 'react';

import type { Action, GroupModule } from 'v2/interfaces/access-control';

type Props = {
  action: Action;
  module: GroupModule;
  handleActionsChange: (action: Action, checked: boolean) => void;
  isChecked: boolean;
  isDisabled: boolean;
};

function Checkbox({ action, handleActionsChange, isChecked, isDisabled }: Props) {
  return (
    <Grid item xs={12} sm={6}>
      <FormControlLabel
        htmlFor={`${action.fullname}-${action.module_id}`}
        label={action.name}
        control={
          <MUICheckbox
            id={`${action.fullname}-${action.module_id}`}
            checked={isChecked}
            onChange={(_, checked) => handleActionsChange(action, checked)}
            disabled={isDisabled}
          />
        }
      />
    </Grid>
  );
}

export default memo(Checkbox);
